export default "__VITE_ASSET__EZ$i7aHp__"